import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import '@learnforge/demo-render/styles.css';
import './styles.css';

import { bootstrapDemoShell } from '@learnforge/demo-kit';
import { makePrng } from '@learnforge/demo-math/numeric';
import { EXPERIMENTS, EXPERIMENT_ORDER } from './experiments';
import { SHOT_PRESETS } from './screenshot-presets';
import { i18n } from './i18n';
import type { FinanceContext } from './types';

bootstrapDemoShell({
  slug: 'finance',
  i18n,
  experiments: EXPERIMENTS,
  order: EXPERIMENT_ORDER,
  shotToExperiment: (id) => SHOT_PRESETS.find((p) => p.id === id)?.exp ?? null,
  extendContext: (base, { shotId }): FinanceContext => ({
    ...base,
    prng: makePrng(shotId !== null ? 0xf14c : Date.now()),
  }),
});
